import React, { useContext, forwardRef } from 'react';
import { Paper, Typography, makeStyles } from '@material-ui/core';
import { blueGrey, blue } from '@material-ui/core/colors';
import moment from 'moment';
import { Twemoji } from 'react-emoji-render';

import { AuthContext } from '../context/AuthContext';

const useStyles = makeStyles((theme) => ({
  message_container: {
    background: '',
    marginBottom: '10px',
    display: 'flex',
    flexDirection: 'column',
  },
  message_content: {
    background: blueGrey[50],
    padding: '10px 7px 0px 10px',
    width: 'fit-content',
    minWidth: '150px',
    maxWidth: '70%',
    color: theme.palette.getContrastText(blueGrey[50]),
  },
  own_message: {
    background: blue[100],
    alignSelf: 'flex-end',
    color: theme.palette.getContrastText(blue[100]),
  },
  text: {
    marginRight: '25px',
  },
}));

const Message = forwardRef(({ text, senderId, timestamp }, ref) => {
  const { currentUser } = useContext(AuthContext);

  const self = senderId === currentUser.uid;
  const classes = useStyles();
  return (
    <div className={classes.message_container}>
      <Paper
        elevation={1}
        className={`${classes.message_content} ${self && classes.own_message}`}
        ref={ref}
      >
        <Typography variant='body1' className={classes.text}>
          <Twemoji text={text} />
        </Typography>
        <Typography
          variant='subtitle2'
          color='textSecondary'
          align='right'
          style={{ fontSize: '.75rem' }}
        >
          {moment.utc(timestamp).local().format('LT')}
        </Typography>
      </Paper>
    </div>
  );
});

export default Message;
